import {
  GetVisibleTabRouteArgs,
  TAB_CHILD_ROUTE_MAP,
  TAB_CHILD_ROUTE_PRIORITY
} from "./TabVisibility.types";

export function getVisibleTabRoute({
  tabId,
  tabPermission,
  fallbackRoute
}: GetVisibleTabRouteArgs): string {
  const children = tabPermission?.children || {};
  const routeMap = TAB_CHILD_ROUTE_MAP[tabId] || {};
  const priorityOrder =
    TAB_CHILD_ROUTE_PRIORITY[tabId] || Object.keys(routeMap);

  for (const childId of priorityOrder) {
    const childConfig = children[childId];
    const isVisible = childConfig?.isVisible === true;

    if (!isVisible) {
      continue;
    }

    if (typeof childConfig?.href === "string" && childConfig.href.length > 0) {
      return childConfig.href;
    }

    if (routeMap[childId]) {
      return routeMap[childId];
    }
  }

  return fallbackRoute;
}
